const video = {
	group: "block",
	attrs: {
		title: { default: null },
		path: { default: null },
		isLink: { default: true },
	},
};

export default video;
